import React from 'react';
import { SimpleGrid, Box, Heading } from "@chakra-ui/react";
import CandidatureCard from "./CandidatureCard";
import { Candidature } from './CandidatureService';
import { Mission } from '../mission/MissionService';

interface MesCandidaturesListProps {
    candidatures: (Candidature & { mission?: Mission })[];
}

const MesCandidaturesList: React.FC<MesCandidaturesListProps> = ({ candidatures }) => {
    return (
        <Box>
            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
                {candidatures.map((candidature) => (
                    <CandidatureCard
                        key={candidature.id}
                        candidature={candidature}
                    />
                ))}
            </SimpleGrid>
        </Box>
    );
};

export default MesCandidaturesList;